import { create } from "zustand";

type CloseDossierStore = {
    currentlyClosingDossierNummer: string | null;
    setCurrentlyClosingDossierNummer: (dossierNummer: string | null) => void;
};

export const useCloseDossierStore = create<CloseDossierStore>((set) => ({
    currentlyClosingDossierNummer: null,
    setCurrentlyClosingDossierNummer: (currentlyClosingDossierNummer) => set({ currentlyClosingDossierNummer }),
}));
